export const BoardType = {
  Task: "task",
  Load: "load",
};
